import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/introduce',
    name: 'Introduce',
    meta:{title:''},
    component: () => import('@/views/introduce'),
    redirect: '/introduce/advantage',
    children:[
      { 
        name: 'Advantage',
        path: '/introduce/advantage',
        component: () => import('@/views/introduce/advantage'),
      },
      { 
        name: 'Postion',
        path: '/introduce/position',
        component: () => import('@/views/introduce/position'),
      },
      { 
        name: 'Layout',
        path: '/introduce/layout',
        component: () => import('@/views/introduce/layout'),
      },
      { 
        name: 'Manage',
        path: '/introduce/manage',
        component: () => import('@/views/introduce/manage'),
      },
      { 
        name: 'Pictures',
        path: '/introduce/pictures',
        component: () => import('@/views/introduce/pictures'),
      }
    ]
  },
  {
    path: '/cooperate',
    name: 'Cooperate',
    meta:{title:''},
    component: () => import('@/views/cooperate'),
  },
  {
    path: '/news',
    name: 'News',
    meta:{title:''},
    component: () => import('@/views/news'),
  },
  {
    path: '/show',
    name: 'Show',
    meta:{title:''},
    component: () => import('@/views/show'),
  },
  {
    path: '/about',
    name: 'About',
    meta:{title:''},
    component: () => import('@/views/about'),
    redirect: '/about/summary', 
    children:[
      { 
        name: 'Summary',
        path: '/about/summary',
        component: () => import('@/views/about/summary'),
      },
      { 
        name: 'Contact',
        path: '/about/contact',
        component: () => import('@/views/about/contact'),
      },
      { 
        name: 'Arrive',
        path: '/about/arrive',
        component: () => import('@/views/about/arrive'),
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(){
    //x代表横坐标，y代表纵坐标
    // return {x:0,y:0};
  },
  base: process.env.BASE_URL,
  routes
})

export default router
